import { apiClient } from './client';

export function getShopLogs (shopId: number | string, timeRange: string) {
  return apiClient.get(`/datadog/logs/shop/${shopId}/${timeRange}`);
}

export function getReturnLogs (returnId: number | string, timeRange: string) {
  return apiClient.get(`/datadog/logs/return/${returnId}/${timeRange}`);
}
